export default __webpack_public_path__ + "static/media/family-and-kids.60664d23.jpg";